import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import React from "react";

export interface DatePickerProps {
    value: Date | null;
    onChange(date: Date | null, value?: string | null): any;
    onError?(error: unknown): any;
    label: React.ReactNode;
    required?: boolean | undefined;
    disabled?: boolean | undefined;
    fullWidth?: boolean | undefined;
    style?: React.CSSProperties | undefined
}

export default function (props: DatePickerProps) {

    const { value, onChange, onError, label, required, fullWidth, disabled, style } = props;

    return (
        <DatePicker<Date, Date>
            label={label}
            inputFormat={'dd/MM/yyyy'}
            value={value}
            onChange={onChange}
            onError={onError}
            //cancelLabel={<Trans translateKey='cancel' namespace='form' capitalize />}
            //leftArrowIcon={<ArrowLeftIcon />}
            //rightArrowIcon={<ArrowRightIcon />}
            //inputVariant="outlined"
            //margin="dense"
            //todayLabel={<Trans translateKey='today' />}
            //showTodayButton
            //keyboardIcon={<CalendarIcon fontSize='small' />}
            //KeyboardButtonProps={{ style: { padding: 0 } }}
            InputAdornmentProps={{ style: { margin: 0 } }}
            //fullWidth={fullWidth}
            //invalidDateMessage={<Trans translateKey='elementInvalid' valuesToReplace={{ element: t('date') }} capitalize />}
            //required={required}                        
            disabled={disabled}
            renderInput={(inputProps) => (
                <TextField
                    {...inputProps}
                    variant="outlined"
                    margin="dense"
                    size="small"
                    disabled={disabled}
                    required={required}
                    fullWidth={fullWidth}
                    style={style}
                />
            )}
        />
    )
}
